<script setup lang="ts">
/**
 * Barre de progression fine (6 px). Le remplissage bleu (4,1:1) est lisible sur sa piste.
 * Les états vigilance et critique changent la couleur ET sont annoncés par le libellé.
 */
import { ProgressIndicator, ProgressRoot } from 'reka-ui'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{ value: number; max: number; label: string; tone?: 'accent' | 'warn' | 'danger' }>(),
  { tone: 'accent' },
)

const ratio = computed(() =>
  props.max > 0 ? Math.min(Math.max(props.value / props.max, 0), 1) : 0,
)

const TONES = { accent: 'bg-accent', warn: 'bg-warn', danger: 'bg-danger' } as const
</script>

<template>
  <ProgressRoot
    :model-value="Math.min(Math.max(value, 0), max)"
    :max="Math.max(max, 1)"
    :aria-label="label"
    class="relative h-1.5 w-full overflow-hidden rounded-full bg-surface-strong"
  >
    <ProgressIndicator
      :class="['h-full rounded-full transition-[width] duration-240 ease-standard', TONES[tone]]"
      :style="{ width: `${ratio * 100}%` }"
    />
  </ProgressRoot>
</template>
